import { useContext } from 'react';
import { SchemaContext } from '../contexts/SchemaProvider';

const useSchema = () => (
  useContext(SchemaContext)
);

export default useSchema;
